// A SZÁMLA HATÓKÖRE a partner-felületen: ügyfél szintű (nincs fiók) / fiók szintű (+ a fiók neve). Ugyanaz a
// KÖZÖS ScopeBadge és ugyanaz a felirat-kulcs, mint a belső hozzárendelés-listán — két helyen áll (számla-kártya,
// Számláim lista), ezért közös.
import { useTranslation } from 'react-i18next';

import { ScopeBadge } from '@/components/shared/scope-badge';
import { Text } from '@/components/ui/text';

export function PortalInvoiceScope({
  accountName,
  badgeOnly = false,
}: {
  accountName: string | null;
  /** Kártyán a fiók neve a meta-sorban áll, ott csak a jelvény kell. */
  badgeOnly?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const scope = accountName === null ? 'client' : 'account';
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5">
      <ScopeBadge scope={scope} label={t(`serviceAssignments.scopeLabel.${scope}`)} />
      {accountName !== null && !badgeOnly && (
        <Text variant="secondary" as="span" className="truncate">
          {accountName}
        </Text>
      )}
    </div>
  );
}
